





































































helpers = require('../../helpers.coffee')

view_model = {
  components:
    draggable: require('vuedraggable')

  props: ['edit_custom_field']

  data: ->
    custom_field: @edit_custom_field || new CustomField()
    pristine: true
    kinds: [
      { value: 'input', label: 'Texto'}
      { value: 'textarea', label: 'Múltiplas Linhas'}
      { value: 'telephone', label: 'Telefone'}
      { value: 'date', label: 'Data'}
      { value: 'email', label: 'E-mail'}
      { value: 'dropdown', label: 'Múltipla Escolha'}
    ],
    option_deleted: false,
    dont_replace: true,
    replace_option: false,
    new_value: ''

  watch:
    edit_custom_field:
      handler: (custom_field) ->
        @custom_field = custom_field
      deep: true

  computed:
    to_updated: ->
      @custom_field.id?

    label_button: ->
      if @to_updated
        'Atualizar'
      else
        'Criar'

    draggable_options: ->
      { disabled: false, filter: '.undraggable' }

    title_modal: ->
      return 'Editar propriedade' if @custom_field.id
      'Criar nova propriedade'

    valid_options: ->
      @custom_field.options.filter (option) -> !option.deleted

  methods:
    close: ->
      @resetOptions()
      @$emit('close-create-modal')

    submit: ->
      @$validator.validateAll().then (success) =>
        @create()

    create: ->
      Loader.on()
      if @to_updated
        params = @custom_field
        params.option_deleted = @option_deleted
        params.replace_option = @replace_option
        params.new_value = @new_value
        new CustomFieldsResource().update(@createCustomFieldSuccess, @handleApiErrors, params)
      else
        new CustomFieldsResource().create(@createCustomFieldSuccess, @handleApiErrors, @custom_field)

    createCustomFieldSuccess: (data) ->
      @resetOptions()
      if @to_updated
        @$emit('custom-field-updated', data.custom_field)
      else
        @$emit('custom-field-created', data.custom_field)

      Loader.off()
      alertify.success 'Salvo com sucesso'
      @custom_field = new CustomField()

    resetOptions: ->
      @option_deleted = false
      @dont_replace = true
      @replace_option = false
      @new_value = ''

    addOption: ->
      @custom_field.options.push({ order: @custom_field.options.length, name: '' })

    priorityUpdated: (options) ->
      @custom_field.options = options

    remove: (option) ->
      if @custom_field.id
        option.deleted = true
        option.name += ' - Campo Excluído'
        @option_deleted = true
      else
        new_options = @custom_field.options.filter (opt) -> opt.order != option.order
        @custom_field.options = new_options.map (opt, index) -> { order: index, name: opt.name }

    checkboxDontReplace: ->
      @replace_option = @dont_replace
      @dont_replace = !@dont_replace

    checkboxReplaceOption: ->
      @dont_replace = @replace_option
      @replace_option = !@replace_option
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/custom_fields/new_modal.vue